import { render } from "./ReferencesInterface.vue?vue&type=template&id=5e3584e1&scoped=true"
import script from "./ReferencesInterface.vue?vue&type=script&lang=js"
export * from "./ReferencesInterface.vue?vue&type=script&lang=js"

import "./ReferencesInterface.vue?vue&type=style&index=0&id=5e3584e1&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3584e1"]])

export default __exports__